import { fontSize, theme } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import {
  RADIO_BUTTON__LABEL_CLASS,
  RADIO_BUTTON__LABEL_TEXT_CLASS,
} from 'src/components/atoms/RadioButton';

const { spacing, text, fonts } = theme;

export const popoverButtonText = css`
  ${fontSize(text.BODY.MD)};
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
`;

export const popoverButtonOptionValue = css`
  color: var(--neutral-black-base);
  margin-left: 0.3rem;
`;

export const popoverContent = css`
  padding: 1rem;

  .${RADIO_BUTTON__LABEL_CLASS} {
    flex-direction: row-reverse;
    text-align: right;

    .${RADIO_BUTTON__LABEL_TEXT_CLASS} {
      margin-right: ${pxToRem(spacing.sm)};
    }
  }
`;
